/* UNSPOKEN behaviour layer. No framework, no dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FMT = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  function addBiz(from, n) {
    var d = new Date(from.getTime()), a = 0;
    while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; }
    return d;
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  function initDrawer() {
    var t = document.querySelector('[data-un-menu-open]');
    var dr = document.getElementById('UnDrawer');
    if (!t || !dr) return;
    var c = dr.querySelector('[data-un-menu-close]'), last = null;
    function open() {
      last = document.activeElement; dr.hidden = false;
      document.body.style.overflow = 'hidden'; t.setAttribute('aria-expanded', 'true');
      var f = dr.querySelector('a, button'); if (f) f.focus();
    }
    function shut() {
      dr.hidden = true; document.body.style.overflow = '';
      t.setAttribute('aria-expanded', 'false'); if (last) last.focus();
    }
    t.addEventListener('click', open);
    if (c) c.addEventListener('click', shut);
    dr.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { shut(); return; }
      if (e.key !== 'Tab') return;
      var it = dr.querySelectorAll('a, button'); if (!it.length) return;
      var f = it[0], l = it[it.length - 1];
      if (e.shiftKey && document.activeElement === f) { e.preventDefault(); l.focus(); }
      else if (!e.shiftKey && document.activeElement === l) { e.preventDefault(); f.focus(); }
    });
  }

  function initFaq() {
    document.querySelectorAll('.un-faq__q').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (!p) return;
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        p.hidden = open;
      });
    });
  }

  function initHeadings() {
    var m = document.getElementById('MainContent') || document.body;
    var hs = m.querySelectorAll('h1');
    for (var i = 1; i < hs.length; i++) {
      var o = hs[i], h2 = document.createElement('h2');
      h2.className = o.className; h2.innerHTML = o.innerHTML;
      o.parentNode.replaceChild(h2, o);
    }
  }

  /* Ships in 2 to 3 business days, then 3 to 5 in transit: a 5 to 8 day window. */
  function initDates() {
    var today = new Date();
    var a = addBiz(today, 5), b = addBiz(today, 8);
    document.querySelectorAll('[data-un-eta]').forEach(function (n) {
      n.innerHTML = 'Order today, arrives between <strong>' + FMT.format(a) + '</strong> and <strong>' + FMT.format(b) + '</strong>.';
    });
    document.querySelectorAll('[data-un-arrives]').forEach(function (n) {
      n.textContent = 'Arrives ' + FMT.format(a) + ' to ' + FMT.format(b);
    });
    /* Real deadline, shown only inside the window it is true. */
    var m = today.getMonth(), d = today.getDate();
    var inWindow = (m === 10) || (m === 11 && d <= 12);
    document.querySelectorAll('[data-un-deadline]').forEach(function (n) { n.hidden = !inWindow; });
  }

  function initGallery() {
    document.querySelectorAll('[data-un-gallery]').forEach(function (g) {
      var tr = g.querySelector('.un-gal__track');
      var dots = g.querySelectorAll('.un-gal__dot');
      if (!tr || !dots.length) return;
      var sl = tr.querySelectorAll('.un-gal__slide');
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (sl[i]) sl[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var ix = Array.prototype.indexOf.call(sl, e.target);
            dots.forEach(function (d, i) { d.setAttribute('aria-current', i === ix ? 'true' : 'false'); });
          });
        }, { root: tr, threshold: 0.6 });
        sl.forEach(function (s) { io.observe(s); });
      }
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-un-product]').forEach(function (root) {
      var el = root.querySelector('[data-un-variants]');
      if (!el) return;
      var vs; try { vs = JSON.parse(el.textContent); } catch (e) { return; }

      var idF = root.querySelector('[data-un-variant-id]');
      var priceEl = root.querySelector('[data-un-price]');
      var sub = root.querySelector('[data-un-submit]');
      var bar = document.querySelector('[data-un-bar-price]');
      var live = root.querySelector('[data-un-live]');
      var rows = root.querySelectorAll('.un-opt__row');

      function chosen() {
        var out = [];
        rows.forEach(function (r) { var h = r.querySelector('input:checked'); out.push(h ? h.value : null); });
        return out;
      }
      function find(opts) {
        return vs.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }

      /* Price deltas, computed from the real variant prices, never hardcoded.
         Each option value is priced against the cheapest variant that has it. */
      function paintDeltas() {
        var base = Math.min.apply(null, vs.map(function (v) { return v.price; }));
        root.querySelectorAll('[data-un-delta]').forEach(function (n) {
          var parts = n.getAttribute('data-un-delta').split('|');
          var idx = parseInt(parts[0], 10) - 1, val = parts[1];
          var cheapest = Math.min.apply(null, vs.filter(function (v) { return v.options[idx] === val; })
                                                 .map(function (v) { return v.price; }));
          var d = cheapest - base;
          n.textContent = d > 0 ? '+' + money(d) : '';
        });
      }

      function sync(announce) {
        var want = chosen(), m = find(want);
        if (!m) { if (sub) { sub.disabled = true; sub.textContent = 'Unavailable'; } return; }
        if (idF) idF.value = m.id;
        if (priceEl) priceEl.textContent = money(m.price);
        if (bar) bar.textContent = money(m.price);
        if (sub) { sub.disabled = !m.available; sub.textContent = m.available ? 'Add to cart' : 'Sold out'; }
        if (announce && live) live.textContent = m.options.join(', ') + '. ' + money(m.price) + '.';
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', m.id);
          window.history.replaceState({}, '', u.toString());
        }
      }

      root.querySelectorAll('.un-opt__row input').forEach(function (i) {
        i.addEventListener('change', function () { sync(true); });
      });
      paintDeltas();
      sync(false);
    });
  }

  function initSticky() {
    var bar = document.querySelector('.un-stickybar');
    var anchor = document.querySelector('[data-un-submit]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(anchor);
  }

  function boot() {
    initDrawer(); initFaq(); initHeadings(); initDates();
    initGallery(); initVariants(); initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
